(function(){
  // === Donde montamos el Quick Add (colecciones + horizontales en PDP/carrito) ===
  const QA_SELECTOR = [
    '.product-card .qa',
    '.horizontal-product .qa',
    '.horizontal-product__media .qa'
  ].join(',');

  // === Arranque ===
  window.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(QA_SELECTOR).forEach(init);
  });

  // Cuando Shopify recarga secciones
  document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll(QA_SELECTOR).forEach(init);
  });

  // Cuando entra HTML dinámico (recomendados, sliders, etc.)
  let moTimer = null;
  const mo = new MutationObserver(() => {
    clearTimeout(moTimer);
    moTimer = setTimeout(() => {
      document.querySelectorAll(QA_SELECTOR).forEach(init);
    }, 60);
  });
  mo.observe(document.documentElement, { childList:true, subtree:true });

  // === Abrir Cart Drawer (varios fallbacks para el tema Concept) ===
  function openCartDrawer(){
    const drawer = document.getElementById('CartDrawer');

    // 1) Clicar el "opener" real si existe
    const opener = document.querySelector([
      '[aria-controls="CartDrawer"]:not(.drawer__close)',
      '[data-action="open-drawer"][data-drawer-id="cart"]',
      '[data-drawer-id="cart"][data-action*="open"]',
      '[data-cart-toggle]',
      '[data-action="toggle-cart"]',
      '.header__action--cart',
      '.js-cart-open',
      '.cart-toggle'
    ].join(','));
    if (opener){
      opener.dispatchEvent(new MouseEvent('click', {bubbles:true, cancelable:true}));
      return;
    }

    // 2) Métodos del custom element
    if (drawer){
      for (const fn of ['open','show','toggle','openDrawer','showDrawer']){
        try{ if (typeof drawer[fn] === 'function'){ drawer[fn](true); return; } }catch(e){}
      }
    }

    // 3) Forzado por clases/atributos (Concept)
    if (drawer){
      drawer.hidden = false;
      drawer.classList.remove('pointer-events-none');
      drawer.querySelectorAll('.invisible, .opacity-0, .pointer-events-none').forEach(el=>{
        el.classList.remove('invisible','opacity-0','pointer-events-none');
      });
      drawer.setAttribute('aria-modal','true');
      drawer.setAttribute('open','');
      const overlay = drawer.querySelector('.overlay');
      if (overlay){
        overlay.setAttribute('aria-expanded','true');
        overlay.setAttribute('aria-controls','CartDrawer');
      }
      document.documentElement.classList.add('drawer-open','no-scroll');
      document.body.style.overflow = 'hidden';
    }
  }

  // === Refrescar HTML del drawer con la Section Rendering API ===
  async function refreshCartDrawer(){
    const drawer = document.getElementById('CartDrawer');
    if (!drawer) return false;

    const sectionId = drawer.getAttribute('data-section-id');
    if (!sectionId) return false;

    // Intento 1: ?sections=<id> (devuelve JSON con el HTML)
    try{
      const url = `${window.location.pathname}?sections=${encodeURIComponent(sectionId)}`;
      const res = await fetch(url, { headers:{'X-Requested-With':'XMLHttpRequest'} });
      if (res.ok){
        const json = await res.json();
        if (json && json[sectionId]){
          drawer.outerHTML = json[sectionId];
          // Avisar por si el tema engancha JS al evento
          document.dispatchEvent(new Event('shopify:section:load'));
          return true;
        }
      }
    }catch(e){ /* fallback abajo */ }

    // Intento 2: /cart?section_id=<id> (algunos temas)
    try{
      const url2 = `/cart?section_id=${encodeURIComponent(sectionId)}`;
      const res2 = await fetch(url2, { headers:{'X-Requested-With':'XMLHttpRequest'} });
      if (res2.ok){
        const html = await res2.text();
        // Si devuelve solo el interior
        const fresh = document.createElement('div');
        fresh.innerHTML = html;
        const newInner = fresh.firstElementChild || fresh;
        if (newInner){
          drawer.innerHTML = newInner.innerHTML;
          document.dispatchEvent(new Event('shopify:section:load'));
          return true;
        }
      }
    }catch(e){}

    return false;
  }

  // === Lógica de cada módulo QA ===
  function init(root){
    if (!root || root.dataset.bound === '1') return;
    root.dataset.bound = '1';

    const openBtn  = root.querySelector('.qa-open');
    const panel    = root.querySelector('.qa-panel');
    const qtyBox   = root.querySelector('.qa-qty');
    const qtyIn    = root.querySelector('.qa-input');
    const minus    = root.querySelector('.qa-minus');
    const plus     = root.querySelector('.qa-plus');
    const addBtn   = root.querySelector('.qa-add');
    const sizeBtns = root.querySelectorAll('.qa-size');

    if (!openBtn || !panel) return;

    let selectedVariantId = null;

    function open(){
      panel.hidden = false;
      openBtn.style.visibility = 'hidden';
    }
    function close(){
      panel.hidden = true;
      openBtn.style.visibility = 'visible';
      selectedVariantId = null;
      if (addBtn) addBtn.disabled = true;
      if (qtyBox) qtyBox.hidden = true;
      sizeBtns.forEach(b=>b.classList.remove('is-selected'));
    }

    openBtn.addEventListener('click', (e)=>{
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      panel.hidden ? open() : close();
    });

    sizeBtns.forEach(btn=>{
      btn.addEventListener('click', (e)=>{
        e.preventDefault(); e.stopPropagation();
        if (btn.disabled) return;
        sizeBtns.forEach(b=>b.classList.remove('is-selected'));
        btn.classList.add('is-selected');
        selectedVariantId = btn.dataset.variantId;
        if (addBtn) addBtn.disabled = false;
        if (qtyBox) qtyBox.hidden = false;
      });
    });

    minus?.addEventListener('click', (e)=>{
      e.preventDefault(); e.stopPropagation();
      qtyIn.value = Math.max(1, (parseInt(qtyIn.value||'1',10)-1));
    });
    plus?.addEventListener('click', (e)=>{
      e.preventDefault(); e.stopPropagation();
      qtyIn.value = (parseInt(qtyIn.value||'1',10)+1);
    });

    // === Añadir al carro + refrescar drawer + abrir drawer ===
    addBtn?.addEventListener('click', async (e)=>{
      e.preventDefault(); e.stopPropagation();
      if (!selectedVariantId) return;
      addBtn.disabled = true;
      try{
        // 1) Añadir
        const res = await fetch('/cart/add.js', {
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({
            id: Number(selectedVariantId),
            quantity: Math.max(1, parseInt(qtyIn.value||'1',10))
          })
        });
        if(!res.ok) throw new Error('Add to cart failed');

        // 2) Refrescar contenido del drawer
        await refreshCartDrawer();

        // 3) Abrir drawer actualizado
        setTimeout(openCartDrawer, 10);

        // 4) Cerrar panel
        close();
      }catch(err){
        console.error(err);
        addBtn.disabled = false;
        alert('No se pudo añadir este artículo.');
      }
    });

    // Cerrar al clicar fuera o con ESC
    document.addEventListener('click', (ev)=>{
      if (!panel.hidden && !panel.contains(ev.target) && !openBtn.contains(ev.target)) close();
    }, true);
    document.addEventListener('keydown', (e)=>{ if(!panel.hidden && e.key === 'Escape'){ close(); } });
  }
})();
